import { PropsWithChildren, useMemo } from 'react';

import { UserGroups } from '@ravago/shared/authentication';

import { AuthenticationContext } from '../contexts/authentication-context';
import { User } from '../models/user.model';

interface Props extends PropsWithChildren {
   isAuthenticated: boolean;
}

const createMockUser = (): User => ({
   uid: '',
   firstname: 'John',
   lastname: 'Doe',
   groups: [UserGroups.ravagoGlobalGroupAdmin],
   sub: '',
   mail: '',
   ravagoCustomerCountryIsoCode: '',
   ravagoCustomerId: 123
});

export const ProducerAuthenticationProviders = ({ isAuthenticated, children }: Props) => {
   const value = useMemo(
      () => ({
         user: isAuthenticated ? createMockUser() : undefined,
         accessToken: isAuthenticated ? 'access-token' : undefined,
         loading: false,
         refreshToken: async () => {
            // no-op
         },
         login: () => {
            // no-op
         },
         logout: () => {
            // no-op
         }
      }),
      []
   );

   return <AuthenticationContext.Provider value={value}>{children}</AuthenticationContext.Provider>;
};
